import type { MaterialIconEntry } from '../types';

import { MATERIAL_ICON_VIEWBOX } from '../types';
import OneTwoThreeIcon from './svgs/123.svg?react';
import AccountCircleIcon from './svgs/account_circle.svg?react';
import AccountTreeIcon from './svgs/account_tree.svg?react';
import AddIcon from './svgs/add.svg?react';
import AdminPanelSettingsFillIcon from './svgs/admin_panel_settings-fill.svg?react';
import AdminPanelSettingsIcon from './svgs/admin_panel_settings.svg?react';
import AlternateEmailIcon from './svgs/alternate_email.svg?react';
import ArrowBackIcon from './svgs/arrow_back.svg?react';
import ArrowDropDownIcon from './svgs/arrow_drop_down.svg?react';
import ArrowDropUpIcon from './svgs/arrow_drop_up.svg?react';
import ArrowForwardIcon from './svgs/arrow_forward.svg?react';
import ArrowLeftIcon from './svgs/arrow_left.svg?react';
import ArrowRightIcon from './svgs/arrow_right.svg?react';
import ArrowSplitIcon from './svgs/arrow_split.svg?react';
import AttachFileIcon from './svgs/attach_file.svg?react';
import BlockIcon from './svgs/block.svg?react';
import BookmarkFillIcon from './svgs/bookmark-fill.svg?react';
import BookmarkIcon from './svgs/bookmark.svg?react';
import CalendarClockFillIcon from './svgs/calendar_clock-fill.svg?react';
import CalendarClockIcon from './svgs/calendar_clock.svg?react';
import CalendarTodayIcon from './svgs/calendar_today.svg?react';
import CardsStackFillIcon from './svgs/cards_stack-fill.svg?react';
import CardsStackIcon from './svgs/cards_stack.svg?react';
import ChatIcon from './svgs/chat.svg?react';
import ChatAddOnIcon from './svgs/chat_add_on.svg?react';
import CheckIcon from './svgs/check.svg?react';
import CheckCircleFillIcon from './svgs/check_circle-fill.svg?react';
import CheckCircleIcon from './svgs/check_circle.svg?react';
import ChecklistIcon from './svgs/checklist.svg?react';
import ChevronLeftIcon from './svgs/chevron_left.svg?react';
import ChevronRightIcon from './svgs/chevron_right.svg?react';
import CloseIcon from './svgs/close.svg?react';
import CodeXmlIcon from './svgs/code_xml.svg?react';
import CollapseContentIcon from './svgs/collapse_content.svg?react';
import ContentCopyIcon from './svgs/content_copy.svg?react';
import ContractFillIcon from './svgs/contract-fill.svg?react';
import ContractIcon from './svgs/contract.svg?react';
import CorporateFareIcon from './svgs/corporate_fare.svg?react';
import DashboardIcon from './svgs/dashboard.svg?react';
import DatabaseIcon from './svgs/database.svg?react';
import DeleteIcon from './svgs/delete.svg?react';
import DescriptionIcon from './svgs/description.svg?react';
import DnsFillIcon from './svgs/dns-fill.svg?react';
import DnsIcon from './svgs/dns.svg?react';
import DownloadIcon from './svgs/download.svg?react';
import DragIndicatorIcon from './svgs/drag_indicator.svg?react';
import DriveFileMoveIcon from './svgs/drive_file_move.svg?react';
import DropdownMenuIcon from './svgs/dropdown_menu.svg?react';
import EditIcon from './svgs/edit.svg?react';
import ExpandContentIcon from './svgs/expand_content.svg?react';
import FilterAltIcon from './svgs/filter_alt.svg?react';
import Flag2Icon from './svgs/flag_2.svg?react';
import FolderIcon from './svgs/folder.svg?react';
import FormatAlignCenterIcon from './svgs/format_align_center.svg?react';
import FormatAlignJustifyIcon from './svgs/format_align_justify.svg?react';
import FormatAlignLeftIcon from './svgs/format_align_left.svg?react';
import FormatAlignRightIcon from './svgs/format_align_right.svg?react';
import FormatBoldIcon from './svgs/format_bold.svg?react';
import FormatColorTextIcon from './svgs/format_color_text.svg?react';
import FormatH1Icon from './svgs/format_h1.svg?react';
import FormatH2Icon from './svgs/format_h2.svg?react';
import FormatIndentDecreaseIcon from './svgs/format_indent_decrease.svg?react';
import FormatIndentIncreaseIcon from './svgs/format_indent_increase.svg?react';
import FormatInkHighlighterIcon from './svgs/format_ink_highlighter.svg?react';
import FormatItalicIcon from './svgs/format_italic.svg?react';
import FormatLineSpacingIcon from './svgs/format_line_spacing.svg?react';
import FormatListBulletedIcon from './svgs/format_list_bulleted.svg?react';
import FormatListNumberedIcon from './svgs/format_list_numbered.svg?react';
import FormatPaintIcon from './svgs/format_paint.svg?react';
import FormatParagraphIcon from './svgs/format_paragraph.svg?react';
import FormatUnderlinedIcon from './svgs/format_underlined.svg?react';
import GroupIcon from './svgs/group.svg?react';
import GroupAddFillIcon from './svgs/group_add-fill.svg?react';
import GroupAddIcon from './svgs/group_add.svg?react';
import HelpIcon from './svgs/help.svg?react';
import HistoryIcon from './svgs/history.svg?react';
import HomeIcon from './svgs/home.svg?react';
import HomeStorageIcon from './svgs/home_storage.svg?react';
import ImportContactsIcon from './svgs/import_contacts.svg?react';
import InboxIcon from './svgs/inbox.svg?react';
import InfoIcon from './svgs/info.svg?react';
import KeepFillIcon from './svgs/keep-fill.svg?react';
import KeepIcon from './svgs/keep.svg?react';
import KeyVerticalIcon from './svgs/key_vertical.svg?react';
import KeyboardArrowDownIcon from './svgs/keyboard_arrow_down.svg?react';
import LanguageIcon from './svgs/language.svg?react';
import LeftPanelCloseIcon from './svgs/left_panel_close.svg?react';
import LeftPanelOpenIcon from './svgs/left_panel_open.svg?react';
import LinkIcon from './svgs/link.svg?react';
import LinkOffIcon from './svgs/link_off.svg?react';
import ListAltIcon from './svgs/list_alt.svg?react';
import LocationOnIcon from './svgs/location_on.svg?react';
import LockIcon from './svgs/lock.svg?react';
import LockOpenIcon from './svgs/lock_open.svg?react';
import LogoutIcon from './svgs/logout.svg?react';
import MailIcon from './svgs/mail.svg?react';
import MenuIcon from './svgs/menu.svg?react';
import MicIcon from './svgs/mic.svg?react';
import MoreHorizIcon from './svgs/more_horiz.svg?react';
import NavAcademyFillIcon from './svgs/nav-academy-fill.svg?react';
import NavAcademyIcon from './svgs/nav-academy.svg?react';
import NavAdminFillIcon from './svgs/nav-admin-fill.svg?react';
import NavAdminIcon from './svgs/nav-admin.svg?react';
import NavAgentCenterFillIcon from './svgs/nav-agent-center-fill.svg?react';
import NavAgentCenterIcon from './svgs/nav-agent-center.svg?react';
import NavAutomationFillIcon from './svgs/nav-automation-fill.svg?react';
import NavAutomationIcon from './svgs/nav-automation.svg?react';
import NavDashboardFillIcon from './svgs/nav-dashboard-fill.svg?react';
import NavDashboardIcon from './svgs/nav-dashboard.svg?react';
import NavDocumentsFillIcon from './svgs/nav-documents-fill.svg?react';
import NavDocumentsIcon from './svgs/nav-documents.svg?react';
import NavHomeFillIcon from './svgs/nav-home-fill.svg?react';
import NavHomeIcon from './svgs/nav-home.svg?react';
import NavLibraryFillIcon from './svgs/nav-library-fill.svg?react';
import NavLibraryIcon from './svgs/nav-library.svg?react';
import NavSearchFillIcon from './svgs/nav-search-fill.svg?react';
import NavSearchIcon from './svgs/nav-search.svg?react';
import NavWorkflowFillIcon from './svgs/nav-workflow-fill.svg?react';
import NavWorkflowIcon from './svgs/nav-workflow.svg?react';
import NotesIcon from './svgs/notes.svg?react';
import NotificationsIcon from './svgs/notifications.svg?react';
import NotificationsOffIcon from './svgs/notifications_off.svg?react';
import OpenInNewIcon from './svgs/open_in_new.svg?react';
import PauseIcon from './svgs/pause.svg?react';
import PaymentsIcon from './svgs/payments.svg?react';
import PercentIcon from './svgs/percent.svg?react';
import PersonIcon from './svgs/person.svg?react';
import PictureInPictureAltIcon from './svgs/picture_in_picture_alt.svg?react';
import ProgressActivityIcon from './svgs/progress_activity.svg?react';
import RefreshIcon from './svgs/refresh.svg?react';
import RemoveIcon from './svgs/remove.svg?react';
import ReplyIcon from './svgs/reply.svg?react';
import ResumeIcon from './svgs/resume.svg?react';
import SaveIcon from './svgs/save.svg?react';
import SaveAsIcon from './svgs/save_as.svg?react';
import ScheduleIcon from './svgs/schedule.svg?react';
import SearchIcon from './svgs/search.svg?react';
import SendIcon from './svgs/send.svg?react';
import SettingsIcon from './svgs/settings.svg?react';
import ShareIcon from './svgs/share.svg?react';
import ShortTextIcon from './svgs/short_text.svg?react';
import SignatureIcon from './svgs/signature.svg?react';
import SplitscreenIcon from './svgs/splitscreen.svg?react';
import StrikethroughSIcon from './svgs/strikethrough_s.svg?react';
import SubscriptIcon from './svgs/subscript.svg?react';
import SuperscriptIcon from './svgs/superscript.svg?react';
import SwapVertIcon from './svgs/swap_vert.svg?react';
import SyncIcon from './svgs/sync.svg?react';
import SyncProblemIcon from './svgs/sync_problem.svg?react';
import TableIcon from './svgs/table.svg?react';
import ThumbDownFillIcon from './svgs/thumb_down-fill.svg?react';
import ThumbDownIcon from './svgs/thumb_down.svg?react';
import ThumbUpFillIcon from './svgs/thumb_up-fill.svg?react';
import ThumbUpIcon from './svgs/thumb_up.svg?react';
import UndoIcon from './svgs/undo.svg?react';
import UploadIcon from './svgs/upload.svg?react';
import VisibilityIcon from './svgs/visibility.svg?react';
import VisibilityOffIcon from './svgs/visibility_off.svg?react';
import WarningIcon from './svgs/warning.svg?react';
import WorkIcon from './svgs/work.svg?react';

const noFill = undefined;

const materialEntry = (
  base: MaterialIconEntry['base'],
  filled?: MaterialIconEntry['filled'],
  description?: string,
): MaterialIconEntry => ({
  type: 'material',
  base,
  ...(filled ? { filled } : {}),
  ...(description ? { description } : {}),
  viewBox: MATERIAL_ICON_VIEWBOX,
  preserveColors: false,
});

/**
 * Material Symbols **Rounded** self-hosted at opsz 24 (`./svgs/*.svg` via SVGR `?react`). EDS keys map to Material ligature names in
 * `iconography` — see product icon list in design docs.
 */
export const MATERIAL_ICON_ENTRIES = {
  'account-circle': materialEntry(
    AccountCircleIcon,
    noFill,
    "Use as a decorative indicator specifically for the current user's own account/profile entry point (e.g., an account menu item, profile settings link). Distinct from user, which is a generic single-person reference elsewhere in the UI (assigned owner, created by).",
  ),
  'add-new-conversation': materialEntry(
    ChatAddOnIcon,
    noFill,
    'Use as an interactive control to start a new conversation/thread (e.g., new chat, new message thread, new AI conversation).',
  ),
  'address-location': materialEntry(
    LocationOnIcon,
    noFill,
    'Use to indicate a static field (read-only display of a value) displaying an address or location value, e.g., mailing address, office location, geo-coordinate.',
  ),
  'admin-settings': materialEntry(
    AdminPanelSettingsIcon,
    AdminPanelSettingsFillIcon,
    'Use as a decorative indicator for admin-only config pages, settings, or features (e.g., admin dashboard nav item, admin-restricted settings section). Signals elevated permissions or control-panel context, distinct from the general user-focused icons.',
  ),
  alert: materialEntry(
    NotificationsIcon,
    noFill,
    'Use to indicate that notifications/alerts are enabled for an item, or as an interactive control to turn alerts on (e.g., "notify me on updates," subscribed status indicator).',
  ),
  'alert-off': materialEntry(
    NotificationsOffIcon,
    noFill,
    'Use to indicate that notifications/alerts are disabled for an item, or as an interactive control to turn alerts off. The direct counterpart to alert — pair together in toggle controls.',
  ),
  'align-center': materialEntry(
    FormatAlignCenterIcon,
    noFill,
    'Aligns selected text/block to the center. Use for titles, callouts, or short standalone lines. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'align-justify': materialEntry(
    FormatAlignJustifyIcon,
    noFill,
    'Aligns selected text/block so both left and right edges are flush. Use for dense body text in print-style or document-like layouts. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'align-left': materialEntry(
    FormatAlignLeftIcon,
    noFill,
    'Aligns selected text/block to the left edge. Typically the default alignment; include in toolbars alongside the other three alignment options as a set. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'align-right': materialEntry(
    FormatAlignRightIcon,
    noFill,
    'Aligns selected text/block to the right edge. Use for numeric columns, signatures, or RTL-adjacent contexts. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'arrow-left': materialEntry(
    ArrowBackIcon,
    noFill,
    'Used for navigation that takes the user to a distinct destination (a different page, an external link, or a meaningful step away from the current context). Arrows carry more visual weight than chevrons and signal a more significant action. Do not use arrows for expand/collapse or carousel controls.',
  ),
  'arrow-right': materialEntry(
    ArrowForwardIcon,
    noFill,
    'Used for navigation that takes the user to a distinct destination (a different page, an external link, or a meaningful step away from the current context). Arrows carry more visual weight than chevrons and signal a more significant action. Do not use arrows for expand/collapse or carousel controls.',
  ),
  attachment: materialEntry(
    AttachFileIcon,
    noFill,
    'Use to indicate or trigger attaching a file to an item (e.g., attach to a comment, message, or record). Also used decoratively to show that an item already has attachments.',
  ),
  block: materialEntry(
    BlockIcon,
    noFill,
    'Use to indicate blocking or restricting an item, user, or action (e.g., block a user, block a request, restricted state).',
  ),
  bold: materialEntry(
    FormatBoldIcon,
    noFill,
    'Applies bold weight to selected text. Use in toolbar/format menus wherever emphasis-via-weight is needed; commonly the first control in a formatting group. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  bookmark: materialEntry(
    BookmarkIcon,
    BookmarkFillIcon,
    'Decorative indicator for saving/marking an item for later reference (e.g., a "bookmark this page" button, a favorited-item marker).',
  ),
  buildings: materialEntry(CorporateFareIcon),
  'calendar-clock': materialEntry(
    CalendarClockIcon,
    CalendarClockFillIcon,
    'Use as a decorative indicator to reference a combined date and time (e.g., appointment scheduling, "remind me on [date] at [time]", tracking time to complete or time to fill). Signals both the day and the moment matter together. Don\'t use this if only one of the two is being captured; use `calendar-today` or `clock` instead.',
  ),
  'calendar-today': materialEntry(
    CalendarTodayIcon,
    noFill,
    'Use as a decorative indicator to reference a specific date with no time component (e.g., due date, birthday, event date)',
  ),
  'caret-down': materialEntry(
    ArrowDropDownIcon,
    noFill,
    'Used to show or hide content within the current context. Preferred in dense, compact layouts because the filled style retains visibility at small sizes. Default icon for any disclosure interaction (expanding a folder in a directory tree, revealing sections within a document, opening an accordion row, or indicating sort direction on a table column). Never use a caret to navigate the user to a new page or location.',
  ),
  'caret-left': materialEntry(
    ArrowLeftIcon,
    noFill,
    'Used to show or hide content within the current context. Preferred in dense, compact layouts because the filled style retains visibility at small sizes. Default icon for any disclosure interaction (expanding a folder in a directory tree, revealing sections within a document, opening an accordion row, or indicating sort direction on a table column). Never use a caret to navigate the user to a new page or location.',
  ),
  'caret-right': materialEntry(
    ArrowRightIcon,
    noFill,
    'Used to show or hide content within the current context. Preferred in dense, compact layouts because the filled style retains visibility at small sizes. Default icon for any disclosure interaction (expanding a folder in a directory tree, revealing sections within a document, opening an accordion row, or indicating sort direction on a table column). Never use a caret to navigate the user to a new page or location.',
  ),
  'caret-up': materialEntry(
    ArrowDropUpIcon,
    noFill,
    'Used to show or hide content within the current context. Preferred in dense, compact layouts because the filled style retains visibility at small sizes. Default icon for any disclosure interaction (expanding a folder in a directory tree, revealing sections within a document, opening an accordion row, or indicating sort direction on a table column). Never use a caret to navigate the user to a new page or location.',
  ),
  check: materialEntry(
    CheckIcon,
    noFill,
    'Use for actions that approve, confirm, or accept something (e.g., approve a request, confirm a step, accept an invite). Represents a user-initiated decision, not a passive state.',
  ),
  'check-circle': materialEntry(
    CheckCircleIcon,
    CheckCircleFillIcon,
    'Use to indicate a positive, successful or completed state (e.g., "saved successfully," "task complete," "verified").',
  ),
  'checklist-approval': materialEntry(
    ChecklistIcon,
    noFill,
    'Decorative indicator for a checklist or approval-related content (e.g., a review checklist, a sign-off summary). In CLM, also a decorative indicator for an approval task — a step in a workflow requiring someone to approve/reject an item.',
  ),
  'chevron-down': materialEntry(
    KeyboardArrowDownIcon,
    noFill,
    'Used for wayfinding within the app structure and sequential navigation between items or steps (vertical navigation panels, breadcrumbs, carousels, steppers, and paginated content). Chevrons do not imply disclosure; they imply progression.',
  ),
  'chevron-left': materialEntry(
    ChevronLeftIcon,
    noFill,
    'Used for wayfinding within the app structure and sequential navigation between items or steps (vertical navigation panels, breadcrumbs, carousels, steppers, and paginated content). Chevrons do not imply disclosure; they imply progression.',
  ),
  'chevron-right': materialEntry(
    ChevronRightIcon,
    noFill,
    'Used for wayfinding within the app structure and sequential navigation between items or steps (vertical navigation panels, breadcrumbs, carousels, steppers, and paginated content). Chevrons do not imply disclosure; they imply progression.',
  ),
  clock: materialEntry(
    ScheduleIcon,
    noFill,
    'Use as a decorative indicator to reference time only, with no date (e.g., duration, a recurring daily time like "9:00 AM", time-of-day filters).',
  ),
  code: materialEntry(
    CodeXmlIcon,
    noFill,
    'Decorative indicator for code, code blocks, or developer-facing content (e.g., an "insert code snippet" button, a code/raw view toggle, a developer section label).',
  ),
  'collapse-chevron': materialEntry(
    CollapseContentIcon,
    noFill,
    "Use to return to a contained item's compact state or shrink the layout of the item (cards, drawers, sections, accordions) between two states (e.g., expanded/detailed vs. collapsed/summary view). This is a general-purpose, reusable control for any component that needs a two-state size toggle.",
  ),
  comment: materialEntry(
    ChatIcon,
    noFill,
    'Use to indicate or open a comment/discussion thread on an item, or to show that comments exist on it.',
  ),
  condition: materialEntry(
    ArrowSplitIcon,
    noFill,
    'Use to signify that conditional logic is applied to an item or object (e.g., visibility rules, if/else/then logic, and/or gates). Indicates that the item\'s behavior or state is governed by rule-based logic rather than being static or unconditional. Appropriate anywhere users need a visual cue that "there\'s a rule attached here" (conditional fields, conditional visibility, branching logic indicators).',
  ),
  copy: materialEntry(
    ContentCopyIcon,
    noFill,
    'Use as an interactive control to duplicate content to clipboard (e.g., copy link, copy value, copy text) — distinct from edit, which modifies content in place.',
  ),
  dashboard: materialEntry(
    DashboardIcon,
    noFill,
    'Decorative indicator for a dashboard, overview view, a landing page that aggregates key info/metrics.',
  ),
  database: materialEntry(
    DatabaseIcon,
    noFill,
    'Decorative indicator for data storage, data sources, or database-related features (e.g., a data source connections page, a backend data view label).',
  ),
  description: materialEntry(
    DescriptionIcon,
    noFill,
    'Use as an interactive control to add, edit, or view a free-text description attached to an item (e.g., a question, section, or field). Grey/hint-colored when no description is set yet, brand-colored once one exists.',
  ),
  'dislike-thumb-down': materialEntry(
    ThumbDownIcon,
    ThumbDownFillIcon,
    'Use as an interactive control to give negative feedback on an item (e.g., flag/dislike a response, downvote, rate unhelpful). The direct counterpart to thumb_up.',
  ),
  document: materialEntry(
    ContractIcon,
    ContractFillIcon,
    'Decorative indicator for a document or document-related view (e.g., a documents section entry, a document representation in a list).',
  ),
  download: materialEntry(
    DownloadIcon,
    noFill,
    'Use as an interactive control to save a file or content locally (e.g., download report, export file).',
  ),
  'drag-and-drop-indicator': materialEntry(
    DragIndicatorIcon,
    noFill,
    'Use as a decorative handle indicating an item is reorderable via drag-and-drop (e.g., reordering list items, rows, or cards). Not clickable itself — signals the draggable affordance.',
  ),
  dropdown: materialEntry(
    DropdownMenuIcon,
    noFill,
    'Use to indicate a static field whose value was originally selected from a predefined list/dropdown (e.g., status, category, single-select option), now shown in read-only form.',
  ),
  edit: materialEntry(
    EditIcon,
    noFill,
    'Use as an interactive control to modify existing content (e.g., edit a field, rename an item, open edit mode).',
  ),
  email: materialEntry(
    MailIcon,
    noFill,
    'Used for electronic mail, email, envelop, envelope, inbox, internet, letter, mail, message, receive mails, unread',
  ),
  'expand-chevron': materialEntry(
    ExpandContentIcon,
    noFill,
    "Use to reveal a contained item's expanded state or grow the layout of the item (cards, drawers, sections, accordions) between two states (e.g., expanded/detailed vs. collapsed/summary view). This is a general-purpose, reusable control for any component that needs a two-state size toggle.",
  ),
  fields: materialEntry(
    DnsIcon,
    DnsFillIcon,
    'Use to indicate a feature or page that points to custom fields extracted from a legal document (e.g., a "Fields" tab/nav item, a panel showing extracted party names, effective dates, contract value). This is a section-level indicator, do not attach an icon to each individual field.',
  ),
  filter: materialEntry(
    FilterAltIcon,
    noFill,
    'Use as an interactive control to open filtering options for a list or view (e.g., filter by status, filter by date range).',
  ),
  'format-settings': materialEntry(FormatPaintIcon),
  folder: materialEntry(
    FolderIcon,
    noFill,
    'Decorative indicator for a folder or grouping of files/items (e.g., file organization, directory structure).',
  ),
  'folder-move': materialEntry(
    DriveFileMoveIcon,
    noFill,
    'Decorative indicator for moving an item into a different folder (e.g., a "move to folder" menu action).',
  ),
  form: materialEntry(
    ListAltIcon,
    noFill,
    'Decorative indicator for form-related content (e.g., a form template, a form-builder feature). Also an indicator for a form-filling task, a step in a workflow requiring someone to complete a form.',
  ),
  'globe-language': materialEntry(
    LanguageIcon,
    noFill,
    'Decorative indicator for language or locale settings (e.g., a language selector, localization/translation options).',
  ),
  group: materialEntry(
    HomeStorageIcon,
    noFill,
    'Use to indicate a feature or page that points to a grouped collection of documents, clauses, or other CLM items, conceptually similar to the stack of documents/binder a lawyer compiles for a case or matter. Marks the entry point into a bundled collection.',
  ),
  'heading-1': materialEntry(
    FormatH1Icon,
    noFill,
    'Converts selected text into a top-level heading (H1) — the largest/most prominent heading style. Use once per major section/title; typically appears at the top of the heading-level dropdown or button group. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'heading-2': materialEntry(
    FormatH2Icon,
    noFill,
    'Converts selected text into a second-level heading (H2). Use for section titles nested beneath an H1, maintaining document hierarchy. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  help: materialEntry(
    HelpIcon,
    noFill,
    'Decorative indicator for help resources (e.g., a help center link, a support documentation entry).',
  ),
  'highlight-color': materialEntry(
    FormatInkHighlighterIcon,
    noFill,
    'Opens a control to apply a background highlight color behind selected text. Use when the formatting need is to flag/mark a passage (e.g., reviewer annotations, "pay attention here"), distinct from text_color. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'history-activity-log': materialEntry(
    HistoryIcon,
    noFill,
    'Use to trigger or link to a history / activity log view for an item or object (e.g., "view edit history," "see activity log," version/revision timelines).',
  ),
  home: materialEntry(
    HomeIcon,
    noFill,
    'Decorative indicator for the home/landing view of the app.',
  ),
  inbox: materialEntry(
    InboxIcon,
    noFill,
    'Decorative indicator for an inbox or incoming items view (e.g., notifications inbox, incoming requests/messages).',
  ),
  indent: materialEntry(
    FormatIndentIncreaseIcon,
    noFill,
    'Increases the indentation level of the selected paragraph or list item. Use for nesting content further from the margin. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  info: materialEntry(
    InfoIcon,
    noFill,
    "Use to indicate neutral, informational status the user should be aware of but that doesn't require immediate action (e.g., tips, helper text, non-urgent notices).",
  ),
  invisible: materialEntry(
    VisibilityOffIcon,
    noFill,
    'Use to indicate that content is currently hidden/masked, or as an interactive control to hide visible content (e.g., hide password, mask field, "hidden from others" state). The direct counterpart to visible.',
  ),
  italic: materialEntry(
    FormatItalicIcon,
    noFill,
    'Applies italic styling to selected text. Use for lighter emphasis, titles of works, or stylistic distinction. Pairs with bold as a standard emphasis pair. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  key: materialEntry(
    KeyVerticalIcon,
    noFill,
    'Use for API key, SSH key, or other credential/key-related features and actions (e.g., "generate API key," "manage SSH keys," key rotation, viewing/copying a key value). Strictly scoped to literal key/credential objects. Do NOT use this for general access control, permissions, or security settings; those should use a separate icon (e.g., `admin-settings`, `group-add`) to avoid conflating "a key" with "access management" as concepts.',
  ),
  'left-panel-close': materialEntry(
    LeftPanelCloseIcon,
    noFill,
    "Use exclusively for the AppNav vertical navigation panel to collapse the nav panel to compact mode. This is a unique, single-purpose control tied to app-level navigation chrome. Don't reuse it for any other panel, sidebar, or drawer, even if visually similar; use `expand-chevron` and `collapse-chevron` instead.",
  ),
  'left-panel-open': materialEntry(
    LeftPanelOpenIcon,
    noFill,
    "Use exclusively for the AppNav vertical navigation panel to open the nav panel to expanded mode. This is a unique, single-purpose control tied to app-level navigation chrome. Don't reuse it for any other panel, sidebar, or drawer, even if visually similar; use `expand-chevron` and `collapse-chevron` instead.",
  ),
  library: materialEntry(
    ImportContactsIcon,
    noFill,
    'Decorative indicator for a library/collection of reusable reference content (e.g., AI model library, clause library). General-purpose for any curated, browsable collection meant for reuse.',
  ),
  'like-thumb-up': materialEntry(
    ThumbUpIcon,
    ThumbUpFillIcon,
    'Use as an interactive control to give positive feedback on an item (e.g., approve/like a response, upvote, rate helpful).',
  ),
  'line-height': materialEntry(
    FormatLineSpacingIcon,
    noFill,
    'Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  link: materialEntry(
    LinkIcon,
    noFill,
    'Use to indicate or trigger associating/connecting two items (e.g., link a document to a record, link related tickets). Also used for hyperlink-insertion in text editors.',
  ),
  'list-ordered-numbered': materialEntry(
    FormatListNumberedIcon,
    noFill,
    'Converts selected content into a numbered (ordered) list. Use when sequence or ranking matters (steps, rankings). Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'list-unordered-bullet': materialEntry(
    FormatListBulletedIcon,
    noFill,
    'Converts selected content into a bulleted (unordered) list. Use when items are equally weighted with no inherent order. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  loading: materialEntry(
    ProgressActivityIcon,
    noFill,
    'Animated — smooth rotation',
  ),
  'lock-key-hole': materialEntry(
    LockIcon,
    noFill,
    'Use to indicate that an item is locked/restricted (e.g., read-only field, locked record, restricted access state), or as an interactive control to lock it.',
  ),
  'lock-key-hole-open': materialEntry(
    LockOpenIcon,
    noFill,
    'Use to indicate that an item is unlocked/editable, or as an interactive control to unlock it. The direct counterpart to lock.',
  ),
  logout: materialEntry(
    LogoutIcon,
    noFill,
    "Use as an interactive control to sign the current user out of the application (e.g., a 'Log out' menu action, ending the active session).",
  ),
  menu: materialEntry(
    MenuIcon,
    noFill,
    'Opens the primary navigation where it is not on screen — the drawer on small viewports. Reach for it only when navigation is hidden behind it; a menu of actions on a row or a page is `more`.',
  ),
  mention: materialEntry(
    AlternateEmailIcon,
    noFill,
    'Decorative indicator for mentioning a user or item (e.g., an @-mention affordance in comments, a tagging feature).',
  ),
  microphone: materialEntry(
    MicIcon,
    noFill,
    'Decorative indicator for voice input or audio recording (e.g., a dictation button, a voice-note feature).',
  ),
  'minus-remove': materialEntry(RemoveIcon),
  money: materialEntry(
    PaymentsIcon,
    noFill,
    'Use to indicate a static field displaying a monetary value. This icon is intentionally universal/generic (not tied to a specific currency symbol) to comply with internationalization requirements — the field\'s actual currency and locale formatting (e.g., "EUR 1,234,567.89" vs "1.234.567,89 USD") is handled by the field content itself, not the icon.',
  ),
  more: materialEntry(
    MoreHorizIcon,
    noFill,
    'Use to indicate an overflow menu with additional actions not shown directly. Use when action options exceed available toolbar space.',
  ),
  'nav-academy': materialEntry(
    NavAcademyIcon,
    NavAcademyFillIcon,
    'Use as a decorative indicator for the Evisort Academy entry point (e.g., a top-bar learning/help affordance). Distinct from help, which opens contextual page help rather than external learning content.',
  ),
  'nav-admin': materialEntry(
    NavAdminIcon,
    NavAdminFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the admin console. Distinct from admin-settings and settings-gear, which are the general-purpose admin/settings glyphs used outside primary navigation.',
  ),
  'nav-agent-center': materialEntry(
    NavAgentCenterIcon,
    NavAgentCenterFillIcon,
    'Use as a decorative indicator for the primary navigation entry into Agent Center.',
  ),
  'nav-automation': materialEntry(
    NavAutomationIcon,
    NavAutomationFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the Custom AI workspace group. Distinct from ai-custom-automation, which represents the same concept outside primary navigation.',
  ),
  'nav-dashboard': materialEntry(
    NavDashboardIcon,
    NavDashboardFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the Dashboard workspace group. Distinct from dashboard, which is the general-purpose dashboard/overview glyph used outside primary navigation.',
  ),
  'nav-documents': materialEntry(
    NavDocumentsIcon,
    NavDocumentsFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the Documents workspace group. Distinct from document, which is the general-purpose document glyph used outside primary navigation.',
  ),
  'nav-home': materialEntry(
    NavHomeIcon,
    NavHomeFillIcon,
    'Use as a decorative indicator for the primary navigation entry into Home. Distinct from home, which is the general-purpose home/landing glyph used outside primary navigation.',
  ),
  'nav-library': materialEntry(
    NavLibraryIcon,
    NavLibraryFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the Library workspace group. Distinct from library, which is the general-purpose library glyph used outside primary navigation.',
  ),
  'nav-search': materialEntry(
    NavSearchIcon,
    NavSearchFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the Search workspace group. Distinct from search, which is the general-purpose search glyph/control used outside primary navigation.',
  ),
  'nav-workflow': materialEntry(
    NavWorkflowIcon,
    NavWorkflowFillIcon,
    'Use as a decorative indicator for the primary navigation entry into the Workflow workspace group. Distinct from workflow, which is the general-purpose workflow glyph used outside primary navigation.',
  ),
  number: materialEntry(
    OneTwoThreeIcon,
    noFill,
    'Use to indicate a static field (read-only display of a value) displaying a plain numeric value with no unit or special formatting, e.g., quantity, count, ID number.',
  ),
  'open-external-link': materialEntry(
    OpenInNewIcon,
    noFill,
    'Use to indicate that an action or link will open outside the current app/context (e.g., open in new tab, navigate to an external site). Distinct from link, which is about association/connection, not navigation.',
  ),
  paragraph: materialEntry(
    FormatParagraphIcon,
    noFill,
    'Inserts or indicates a paragraph break/block, or opens paragraph-level formatting options (spacing before/after, paragraph style). Use for controls that act on the whole paragraph rather than selected characters. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  pause: materialEntry(PauseIcon),
  percentage: materialEntry(
    PercentIcon,
    noFill,
    'Use to indicate a static field (read-only display of a value) displaying a percentage value e.g., completion rate, discount, tax rate.',
  ),
  'picture-in-picture-alt': materialEntry(
    PictureInPictureAltIcon,
    noFill,
    'Use as an interactive control to undock or float a panel over the main canvas (e.g., float a side panel as a picture-in-picture window).',
  ),
  pin: materialEntry(KeepIcon, KeepFillIcon),
  plus: materialEntry(
    AddIcon,
    noFill,
    "Use for actions that create or add something new (e.g., add a row, create an item, start a new entry). Represents initiating something that didn't exist before.",
  ),
  reload: materialEntry(RefreshIcon),
  'remove-indent': materialEntry(
    FormatIndentDecreaseIcon,
    noFill,
    'Decreases (removes) the indentation level of the selected paragraph or list item. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  reply: materialEntry(ReplyIcon),
  resume: materialEntry(ResumeIcon),
  save: materialEntry(
    SaveIcon,
    noFill,
    'Decorative indicator for saving changes to an existing item (e.g., a save-edits button).',
  ),
  'save-as': materialEntry(
    SaveAsIcon,
    noFill,
    'Decorative indicator for saving content as a new/separate item, or converting it to a different file format (e.g., a "save as copy" button, a "save as PDF/DOCX" export option). Distinct from save, which updates the existing item in place without creating a new file or format.',
  ),
  search: materialEntry(
    SearchIcon,
    noFill,
    'Use as an interactive control to open or trigger a search function.',
  ),
  send: materialEntry(
    SendIcon,
    noFill,
    'Decorative indicator for submitting/sending content (e.g., a send-message button in a chat-style input).',
  ),
  'settings-gear': materialEntry(
    SettingsIcon,
    noFill,
    'Use as an interactive control to open settings/configuration options for an item, feature, or the app itself. Distinct from more, which surfaces contextual actions rather than configuration.',
  ),
  share: materialEntry(
    ShareIcon,
    noFill,
    'Use as an interactive control to share an item with others (e.g., share a document, share a link, invite to view).',
  ),
  signature: materialEntry(
    SignatureIcon,
    noFill,
    'Decorative indicator for signature-related content (e.g., a signature block, e-signature settings). In CLM use, a decorative indicator for a signing task, a step in a workflow requiring someone to sign a document.',
  ),
  sort: materialEntry(
    SwapVertIcon,
    noFill,
    "Use as an interactive control to open sorting options for a list, with no implied direction. Use this generic icon when sort direction isn't shown until a menu opens.",
  ),
  splitscreen: materialEntry(
    SplitscreenIcon,
    noFill,
    'Use as an interactive control to move an item into a different group or section (e.g., moving a row to another section, reassigning an item to a different container).',
  ),
  'stage-flag': materialEntry(Flag2Icon),
  strikethrough: materialEntry(
    StrikethroughSIcon,
    noFill,
    'Applies a line through selected text, typically to mark content as deleted, resolved, or "no longer applicable" while keeping it visible (e.g., completed to-do items, rejected suggestions). Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  subscript: materialEntry(
    SubscriptIcon,
    noFill,
    'Renders selected text slightly below the baseline, in smaller size. Use for chemical formulas, footnote markers, or mathematical notation. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  superscript: materialEntry(
    SuperscriptIcon,
    noFill,
    'Renders selected text slightly above the baseline, in smaller size. Use for exponents, ordinal suffixes (1st, 2nd), or citation markers. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  sync: materialEntry(
    SyncIcon,
    noFill,
    'Use to indicate that an item is actively syncing or up to date, or as an interactive control to trigger a manual sync/refresh.',
  ),
  'sync-problem-reconnect': materialEntry(
    SyncProblemIcon,
    noFill,
    'Use to indicate that syncing has failed and a reconnect/retry is needed (e.g., integration disconnected, sync error state). The error-state counterpart to sync.',
  ),
  table: materialEntry(TableIcon),
  'text-area': materialEntry(
    NotesIcon,
    noFill,
    'Use to indicate a static field displaying a longer, multi-line text value (e.g., description, notes, comments).',
  ),
  'text-color': materialEntry(
    FormatColorTextIcon,
    noFill,
    'Opens a control (usually a swatch picker) to change the font color of selected text. Use when the formatting need is about the text itself standing out, not its background. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  'text-input': materialEntry(
    ShortTextIcon,
    noFill,
    'Use to indicate a static field displaying a short, single-line text value (e.g., name, title, short label).',
  ),
  trash: materialEntry(
    DeleteIcon,
    noFill,
    'Use to indicate an action to delete an item (e.g., delete a record, remove a file, empty trash).',
  ),
  underline: materialEntry(
    FormatUnderlinedIcon,
    noFill,
    'Applies an underline beneath selected text. Use sparingly in digital UI since underlines commonly signal links. Reserve for explicit user-applied emphasis, not hyperlink indication. Used in Text Editor features and/or the AI agent conversation box to indicate rich-text formatting actions.',
  ),
  undo: materialEntry(
    UndoIcon,
    noFill,
    'Use as an interactive control to reverse a recent action or return to a previous state (e.g., undo an edit, revert to a prior version, switch back to a previous experience).',
  ),
  unlink: materialEntry(
    LinkOffIcon,
    noFill,
    'Use to indicate or trigger removing an association/connection between two items, or removing a hyperlink. The direct counterpart to link.',
  ),
  upload: materialEntry(
    UploadIcon,
    noFill,
    'Decorative indicator for adding a file from local storage into the app (e.g., an upload-document button). The counterpart to download.',
  ),
  user: materialEntry(
    PersonIcon,
    noFill,
    'Use as a decorative indicator for a single user (e.g., profile page, assigned owner, "created by," individual account reference). The baseline icon for one-person contexts.',
  ),
  'user-group': materialEntry(
    GroupIcon,
    noFill,
    'Use as a decorative indicator for multiple users collectively (e.g., team view, shared workspace, member list, "assigned to group"). Distinguishes plural/collective user contexts.',
  ),
  'user-permissions-add': materialEntry(
    GroupAddIcon,
    GroupAddFillIcon,
    'Use specifically for actions that add users or grant permissions/access (e.g., invite members, add users to a group, extend permissions to additional people). Action-oriented and appear on interactive controls tied to expanding access or membership.',
  ),
  'version-history': materialEntry(
    CardsStackIcon,
    CardsStackFillIcon,
    'Use to trigger or link to a version history view for an item (e.g., "view previous versions," document/file revision list, restore an earlier version). Version History is conceptually a subset of Activity Log but are treated as distinct icons/features because the underlying systems aren\'t yet integrated. Until they\'re consolidated, use `version-history` only for dedicated version-history surfaces, and `history-activity-log` for general activity/edit logs, to avoid the two icons appearing interchangeably to users.',
  ),
  visible: materialEntry(
    VisibilityIcon,
    noFill,
    'Use to indicate that content is currently shown/revealed, or as an interactive control to reveal hidden content (e.g., show password, expand masked field, "visible to others" state).',
  ),
  'warning-exclamation': materialEntry(
    WarningIcon,
    noFill,
    'Use to indicate a problem or risk requiring attention (e.g., validation errors, degraded state, risky action ahead).',
  ),
  'work-briefcase': materialEntry(WorkIcon),
  workflow: materialEntry(AccountTreeIcon),
  x: materialEntry(
    CloseIcon,
    noFill,
    'Use for actions that reject, cancel, dismiss, or remove something (e.g., reject a request, close a modal, clear a filter).',
  ),
} as const satisfies Record<string, MaterialIconEntry>;
